import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router'
import { Subject, Subscription } from 'rxjs';
import { CommonService } from '../../../../../services';
import { filter, finalize, takeUntil } from 'rxjs/operators';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { AMPubscriptionModel, IAMPAnnuityItemsViewModel, IAMPCustomerDetailsViewModel } from '../../../../../models/amp.model';
import { AdobeService } from '../../../../../services/adobe.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-view-high-growth-offers',
  templateUrl: './view-high-growth-offers.component.html',
  styleUrls: ['./view-high-growth-offers.component.css'],
  providers: [DatePipe, CurrencyPipe, DecimalPipe]
})

export class ViewHighGrowthOffersComponent implements OnInit, OnDestroy {
  public displayedColumns: string[] = ['offerId', 'desc', 'minimumQty', 'unitPrice', 'totalPrice', 'requestBtn', 'addBtn'];
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private routerSub: Subscription;
  private tenantId: string;
  private details: IAMPCustomerDetailsViewModel;
  
  public eligibleOffers: any;
  public form: FormGroup;
  public offersControl = new FormControl();
  public OfferChosen: any;
  public threeYC = false;
  public licenseCommitments: number;
  public loadContent = false;
  public customerDetails: IAMPCustomerDetailsViewModel;
  public AMPsubsItemsPendingList: IAMPAnnuityItemsViewModel[] = [];
  public loadingOffers = true;
  public loadingCriteria = true;
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private adobeService: AdobeService,
    private currencyPipe: CurrencyPipe,
    public commonService: CommonService
  ) {
    this.form = new FormGroup({
      offers: this.offersControl,
    });
  }

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505});
  }

  ngOnInit() {
    this.loadContent = true;

    this.adobeService.currentAMPCustomerDetailsWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(filter((value) => value !== null && value !== undefined))
      .subscribe(detail => {
        this.customerDetails = detail;
        this.loadingCriteria = false;
        this.tenantId = this.customerDetails?.customer?.customer_id;
        this.threeYC = this.customerDetails?.customer?.is_3y_commit || this.customerDetails?.customer?.three_year_commitment_status == 'ACCEPTED';
        this.licenseCommitments = this.commonService.toNumber(this.customerDetails?.customer?.number_of_license_commitments);
      });

    this.adobeService.currentEligibleOffersWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(filter((value) => value !== null && value !== undefined))
      .subscribe(offers => {
        this.eligibleOffers = [ ...offers ].filter((offer) => {
          return offer?.eligibilityCriteria?.additionalCriteria?.includes('THREE_YEAR_COMMIT');
        });
        this.loadingOffers = false;
      });

    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url == `/manageSubscriptions/manageAnnuities/AMP/AMPDetails/${this.tenantId}/ViewHighGrowthOffers`) {
          $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505})
        }
      });
  }

  close() {
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
  }

  public goToEditCustomer() {
    this.router.navigate(['../EditAMPEndUser'], { relativeTo: this.activatedRoute });
  }

  public buyNow(element) {
    const confirmSubscription = {} as IAMPAnnuityItemsViewModel;

    confirmSubscription.itemPrice = this.currencyPipe.transform(element.reseller_buy,'AUD', 'symbol-narrow','.2-2');
    confirmSubscription.itemRRPrice = this.currencyPipe.transform(element.rrp,'AUD', 'symbol-narrow','.2-2');;;
    confirmSubscription.previewStockCode = element.offerId;
    confirmSubscription.description = element.stock_description;
    confirmSubscription.quantity = element?.eligibilityCriteria?.minQuantity;
    confirmSubscription.totalPrice = element?.eligibilityCriteria?.minQuantity * this.commonService.toNumber(element.reseller_buy);

    this.adobeService.monitorAMPPendingSubscriptions([confirmSubscription]);
    this.router.navigate(['ConfirmAMPProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
  }

  public requestThreeYC(element) {
    this.adobeService.extra3YCOption = element?.eligibilityCriteria?.minQuantity?.toString();
    this.goToEditCustomer();
  }

  public minQtyOK(qty: string | number): boolean {
    return this.commonService.toNumber(qty) <= this.licenseCommitments;
  }

  ngOnDestroy() {
    this.ngUnsubscribe?.next();
    this.ngUnsubscribe?.complete();
    this.routerSub?.unsubscribe();
  }
}
